import { CssBaseline } from '@mui/material'

import { QueryProvider } from './hooks/useQueryClient'
import { ThemeProvider } from './hooks/useTheme'
import Routes from './routes'

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <QueryProvider>
        <Routes />
      </QueryProvider>
    </ThemeProvider>
  )
}

export default App
